import { PermissionCode, ResourceCode } from '@/const/code'

export default [
  {
    path: '/graduation/graduation-condition',
    name: 'graduation_condition',
    component: () => import('@/views/graduation/GraduationCondition.vue'),
    meta: {
      pageTitle: 'Xét duyệt làm khóa luận',
      breadcrumb: [
        {
          text: 'Quản lý đào tạo',
          active: false,
        },
        {
          text: 'Xét duyệt làm khóa luận',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.GRADUATION_CONDITION,
    },
  },
  {
    path: '/graduation/graduation-class',
    name: 'graduation_class',
    component: () => import('@/views/graduation/GraduationClass.vue'),
    meta: {
      pageTitle: 'Xếp loại tốt nghiệp',
      breadcrumb: [
        {
          text: 'Quản lý đào tạo',
          active: true,
        },
        {
          text: 'Xếp loại tốt nghiệp',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.GRADUATION_CLASS,
    },
  },
  {
    path: '/category/graduate-dissertation',
    name: 'graduateDissertation',
    component: () => import('@/views/graduate-dissertation/Index.vue'),
    meta: {
      pageTitle: 'Đề tài khóa luận tốt nghiệp',
      breadcrumb: [
        {
          text: 'Danh mục',
          active: false,
        },
        {
          text: 'Đề tài khóa luận tốt nghiệp',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.GRADUATION_DISSERTATION,
    },
  },
  {
    path: '/graduationProjectRegisterRound',
    name: 'graduationProjectRegisterRound',
    component: () => import('@/views/graduation-project-register-round/GraduationProjectRegisterRound.vue'),
    meta: {
      pageTitle: 'Danh sách đợt đăng ký KLTN',
      breadcrumb: [
        {
          text: 'Quản lý đợt đăng ký KLTN',
          active: false,
        },
        {
          text: 'Quản lý đợt đăng ký KLTN',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.GRADUATION_PROJECT_REGISTER_ROUND,
    },
  },
  {
    path: '/graduationRegisterRound',
    name: 'graduationRegisterRound',
    component: () => import('@/views/graduation-register-round/GraduationRegisterRound.vue'),
    meta: {
      pageTitle: 'Danh sách đợt đăng ký tốt nghiệp',
      breadcrumb: [
        {
          text: 'Quản lý đợt đăng ký tốt nghiệp',
          active: false,
        },
        {
          text: 'Danh sách đợt đăng ký tốt nghiệp',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.GRADUATION_REGISTER_ROUND,
    },
  },
]
